import { message } from 'antd';
import { useMutation, useQueryClient } from 'react-query';
import { BranchesService } from '../../services';
import { IBranchTransferExecuteValues, IBranchTransferSummary } from '../../interfaces';

export const useBranchTransfer = (onSucceed?: (summary: IBranchTransferSummary) => void) => {
  const queryClient = useQueryClient();

  const { mutate, isLoading } = useMutation<IBranchTransferSummary, Error, IBranchTransferExecuteValues>(
    async (values) => {
      const result = await BranchesService.executeTransfer(values);
      if (result.status === 200) return result.data;
      throw new Error(result.data as string);
    },
    {
      onSuccess: (summary) => {
        message.success(`Köçürüldü: ${summary.declarations} bağlama, ${summary.customers} müştəri, ${summary.admins} admin. Köhnə filial deaktiv edildi.`);
        queryClient.invalidateQueries('branches-select');
        onSucceed?.(summary);
      },
      onError: (error) => {
        message.error(error.message);
      },
    },
  );

  return { submit: mutate, isSubmitting: isLoading };
};
